<template lang="html">
    <div class="panel panel-default" id="sublime-table-container">
        <button class="btn btn-warning btn-sm pull-right export-button"
              data-toggle="tooltip"
              data-placement="top"
              title="Export this chart's data as CSV"
              v-if="this.$store.getters.filteredStats.length > 0"
              @click.stop="exportCSV(reportName)">
        <i class="fas fa-download"></i>
      </button>
        <div class="table-responsive" v-if="sortedStats.length > 0">
          <table class="table table-striped table-sm table-responsive-sm">
              <thead>
                  <tr>

                      <th valign="middle" @click.stop="sort('CourseTitle')" :class="{ 'sort-key': this.sortKey === 'CourseTitle' }">
                        Course
                      </th>

                      <th valign="middle" @click.stop="sort('CohortTitle')" :class="{ 'sort-key': this.sortKey === 'CohortTitle' }">
                        Cohort
                      </th>

                      <th valign="middle" @click.stop="sort('UserFullname')" :class="{ 'sort-key': this.sortKey === 'UserFullname' }">
                        Participant
                      </th>

                      <th valign="middle" @click.stop="sort('Email')" :class="{ 'sort-key': this.sortKey === 'Email' }">
                        Email
                      </th>

                      <th valign="middle" @click.stop="sort('ProgressPercent')" :class="{ 'sort-key': this.sortKey === 'ProgressPercent' }">
                        Progress %
                      </th>

                      <th valign="middle" @click.stop="sort('DiscussionPosts')" :class="{ 'sort-key': this.sortKey === 'DiscussionPosts' }">
                        Reflection Posts
                      </th>

                      <th valign="middle" @click.stop="sort('ChallengesTaken')" :class="{ 'sort-key': this.sortKey === 'ChallengesTaken' }">
                        Challenges Taken
                      </th>

                      <th valign="middle" @click.stop="sort('FeedbackScore')" :class="{ 'sort-key': this.sortKey === 'FeedbackScore' }">
                        Feedback Score
                      </th>

                      <th valign="middle" @click.stop="sort('LastLoginTS')" :class="{ 'sort-key': this.sortKey === 'LastLoginTS' }">
                        Last Login
                      </th>

                  </tr>
              </thead>

              <tbody>

                  <tr v-for="stat in sortedStats">
                      <td>{{ stat.CourseTitle }}</td>
                      <td>{{ stat.CohortTitle }}</td>
                      <td>{{ stat.UserFullName }}</td>
                      <td>{{ stat.Email }}</td>
                      <td>{{ stat.ProgressPercent }}%</td>
                      <td>{{ stat.DiscussionPosts }}</td>
                      <td>{{ stat.ChallengesTaken }}</td>
                      <td>{{ stat.FeedbackScore }}</td>
                      <td>{{ timeSince(stat.LastLoginTS) }}</td>
                  </tr>

              </tbody>
          </table>
        </div>

        <div class="panel-footer" v-else>

          <div class="text-center text-muted">
            <i class="fas fa-info-circle"></i>
            <small>
                Please <strong>make sure at least a single Group, Course and Cohort each is selected</strong> at the top of this page. If you require any further assistance, please contact <a href="mailto:programsupport@personalleadership.com">programsupport@personalleadership.com</a>.
            </small>
          </div>

        </div>
    </div>
</template>

<script>
import moment from 'moment'
import csvHelper from '@/utils/csv-helper'

export default {
  data () {
    return {
      /** Attribute Names mapped as Column Names */
      attributeMap: {
        'Course': 'CourseTitle',
        'Cohort': 'CohortTitle',
        'Participant': 'UserFullName',
        'Email': 'Email',
        'Progress %': 'ProgressPercent',
        'Reflection Posts': 'DiscussionPosts',
        'Challenges Taken': 'ChallengesTaken',
        'Feedback Score': 'FeedbackScore',
        'Last Login': 'LastLoginTS'
      },
      sortKey: 'ProgressPercent',
      sortDirection: 'asc',
      sortedStats: []
    }
  },

  beforeDestroy () {
    this.eventHub.$off('groupCourseCohortFilterUpdated')
    this.eventHub.$off('sublimeTableExported')
  },

  mounted () {
    this.sort(this.sortKey)
    this.eventHub.$on('groupCourseCohortFilterUpdated', this.sort)
    this.eventHub.$on('sublimeTableExported', this.exportTable)
  },

  computed: {
    stats () {
      return this.$store.getters.filteredStats
    },

    indicatorClasses () {
      return {
        'fas': true,
        'fa-caret-up': this.sortDirection === 'asc',
        'fa-caret-down': this.sortDirection === 'desc'
      }
    },

    reportName () {
      // eslint-disable-next-line
      return _.snakeCase('FilteredStats')
    }
  },

  methods: {
    timeSince (dateString) {
      if (dateString !== '01/01/0001 12:00:00 AM') {
        return moment.tz(dateString, 'MM/DD/YYYY hh:mm:ss tt', 'America/New_York').fromNow()
      } else {
        return 'NO LOGIN'
      }
    },

    sort (key = this.sortKey) {
      let sortedStats = []
      if (this.sortKey === key) {
        switch (this.sortDirection) {
          case 'desc':
            this.sortDirection = 'asc'
            break

          default:
            this.sortDirection = 'desc'
            break
        }
      }
      this.sortKey = key
      /* eslint-disable */
      // Covert dates to momentJS instances before comparing them
      sortedStats = (this.sortKey !== 'LastLoginTS')
                  ? _.sortBy(this.stats, this.sortKey)
                  : _.sortBy(this.stats, (stat) => { return moment(stat.LastLoginTS, 'MM/DD/YYYY hh:mm:ss tt') })
      /* eslint-enable */

      if (this.stats.length > 0) {
        switch (this.sortDirection) {
          case 'asc':
            this.sortedStats = sortedStats
            break

          default:
            this.sortedStats = sortedStats.reverse()
            break
        }
      }
    },

    exportTable () {
      let stats = this.sortedStats
      let columns = [
        'CourseTitle',
        'CohortTitle',
        'UserFullName',
        'Email',
        'ProgressPercent',
        'DiscussionPosts',
        'ChallengesTaken',
        'FeedbackScore',
        'LastLoginTS'
      ]
      // eslint-disable-next-line
      let rows = _.map(stats, (stat) => {
        return {
          'CourseTitle': stat.CourseTitle,
          'CohortTitle': stat.CohortTitle,
          'UserFullName': stat.UserFullName,
          'Email': stat.Email,
          'ProgressPercent': stat.ProgressPercent,
          'DiscussionPosts': stat.DiscussionPosts,
          'ChallengesTaken': stat.ChallengesTaken,
          'FeedbackScore': stat.FeedbackScore,
          'LastLoginTS': (stat.LastLoginTS === '01/01/0001 12:00:00 AM') ? 'NO LOGIN' : stat.LastLoginTS
        }
      })

      return csvHelper.export(
        rows,
        columns,
        columns,
        this.reportName
      )
    }
  }
}
</script>

<style lang="css" scoped>
th {
  position: relative;
  cursor: pointer;
  font-size: 0.9em;
}

td {
  font-size: 0.9em;
}

i.fas.fa-caret-up,
i.fas.fa-caret-down,
.sort-indicator {
  color: rgba(255, 104, 0, 1.00) !important;
}

#sublime-table-container {
  position: relative;
}

th.sort-key {
  border-bottom: 2px solid #ff6800;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/SublimeTable.vue